// CADASTRO PÚBLICO: as duas únicas rotas que o app chama antes de existir uma
// organização utilizável — POST /v1/signup (a conta) e POST
// /v1/onboarding/company (o nome de verdade da empresa). Espelham a feature
// `signup` do back.
//
// São só duas funções, e é de propósito que não estão em ./plans.js: o degrau
// SEGUINTE do onboarding é escolher o plano, mas "seguinte" é sequência de
// telas, não parentesco de dados. Nada aqui conhece plano, assinatura ou Stripe,
// e nada de lá conhece cadastro — os dois módulos não se importariam.
//
// Este é também o único módulo de domínio da quebra SEM um src/hooks/use-*.ts:
// as duas telas que o consomem (/signup e /onboarding/organization) são
// imperativas — `try/catch` com `useState`, sem TanStack Query. Não há cache a
// invalidar porque, nas duas, o que muda depois do POST é a SESSÃO, e quem
// derruba o resto é `invalidateAppAccess()` + `queryClient.clear()`.
import { api, toApiError } from "./client.js";

// POST /v1/signup — cria a conta inteira numa transação. NÃO devolve sessão:
// quem autentica é o clique no link de confirmação. `callbackURL` diz para
// onde esse clique leva (o back só aceita destinos das origens dele).
export async function signup(input: {
  name: string;
  email: string;
  password: string;
  callbackURL: string;
}): Promise<{ verificationSent: boolean }> {
  const { data, error } = await api<{ verificationSent: boolean }>("/v1/signup", {
    method: "POST",
    body: input,
  });
  if (error) throw toApiError("POST /v1/signup", error);
  return data;
}

// POST /v1/onboarding/company — a empresa provisória (batizada com o nome da
// pessoa no cadastro) ganha o nome de verdade e o tipo de cliente.
// Idempotente: o passo seguinte é o Checkout, que pode falhar, e quem volta
// reenvia isto sem esbarrar em "já feito".
export async function completeCompanyOnboarding(input: {
  companyName: string;
  companyType: "unica" | "grupo";
  // Só o cliente 'grupo' manda: ali `companyName` é o nome da REDE, e a marca
  // que já nasceu com a conta precisa do nome dela. Em 'unica' os dois nomes
  // são a mesma resposta e o back resolve sozinho.
  brandName?: string;
}): Promise<{ companyId: string; companyType: "unica" | "grupo" }> {
  const { data, error } = await api<{ companyId: string; companyType: "unica" | "grupo" }>(
    "/v1/onboarding/company",
    { method: "POST", body: input },
  );
  if (error) throw toApiError("POST /v1/onboarding/company", error);
  return data;
}
